/** Sélecteur segmenté Le Desk (iter374 pt 4, forme unique) : un seul contour 0.5 px #2a2a30, rayon 8 px ; option choisie remplie
 *  (fond teinté de SA couleur, texte de la couleur), coins qui épousent le contour, aucune bordure interne. options = [[value, label, color]]. */
export default function Segmented({ value, onChange, options, disabled, testId }) {
  return (
    <div className="inline-flex" role="radiogroup" style={{ gap: 0, border: "0.5px solid #2a2a30", borderRadius: 8, overflow: "hidden", background: "#121216", opacity: disabled ? .6 : 1 }} data-testid={testId}>
      {options.map(([v, label, color]) => { const on = value === v; return (
        <button key={v} type="button" role="radio" aria-checked={on} disabled={disabled} onClick={() => onChange(v)}
          style={{ fontSize: 11.5, padding: "7px 14px", fontWeight: on ? 700 : 400, color: on ? color : "#9a9aa2", background: on ? `${color}2e` : "transparent", border: "none", transition: "background-color .15s, color .15s" }}
          data-testid={`${testId}-${v}`} data-on={on}>{label}</button>); })}
    </div>
  );
}
